import React, { FC, useEffect, useState } from 'react';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { getMemberInfo } from 'src/utils/common';
import { useQueryClient } from '@tanstack/react-query';
import { familyDataStore } from 'src/store/familyInfo';

import TabButton from 'src/components/atoms/buttons/TabButton';
import HousingLoan from 'src/components/molecules/table/HousingLoan';
import HousingSaving from 'src/components/molecules/table/HousingSaving';
import HousingRentF from 'src/components/molecules/table/HousingRentF';
import HousingRentM from 'src/components/molecules/table/HousingRentM';
import HousingRentP from 'src/components/molecules/table/HousingRentP';

import { houseLoanInfoDataFn } from 'src/fetch/stepC/houseLoan';
import { houseRentFInfoDataFn } from 'src/fetch/stepC/houseRentF';
import { houseRentMInfoDataFn } from 'src/fetch/stepC/houseRentM';
import { houseRentPInfoDataFn } from 'src/fetch/stepC/houseRentP';
import { houseSaveInfoDataFn } from 'src/fetch/stepC/houseSaving';

import { loanDataStore } from 'src/store/housingfunds/loan';
import { rentFDataStore } from 'src/store/housingfunds/rentf';
import { rentMDataStore } from 'src/store/housingfunds/rentm';
import { rentPDataStore } from 'src/store/housingfunds/rentp';
import { savingsDataStore } from 'src/store/housingfunds/savings';

import './style.scss';

interface Props {
  type: string;
}
const CreditCardSet: FC<Props> = ({ type }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const familyInfoDataState = familyDataStore((state: any) => state.bind);
  const loadingSate = loadingModalViewStore((state: any) => state.set);

  // 주택자금저축
  const savingDataState = savingsDataStore((state: any) => state.bind);
  const savingParam = savingsDataStore((state: any) => state.param);
  // 장기주택저당차입금
  const loanDataState = loanDataStore((state: any) => state.bind);
  const loanParam = loanDataStore((state: any) => state.param);
  // 금융기관자입(전세)
  const rentFDataState = rentFDataStore((state: any) => state.bind);
  const rentFParam = rentFDataStore((state: any) => state.param);
  // 월세
  const rentMDataState = rentMDataStore((state: any) => state.bind);
  const rentMParam = rentMDataStore((state: any) => state.param);
  // 사인간차입(금전소비대차,임대차)
  const rentPDataState = rentPDataStore((state: any) => state.bind);
  const rentPParam = rentPDataStore((state: any) => state.param);

  const param = userInfoData;

  // 주택자금저축
  useEffect(() => {
    houseSaveInfoDataFn(errorModalState, param, savingDataState, queryClient, familyInfoDataState);
  }, [savingParam]);
  // 장기주택저당차입금
  useEffect(() => {
    houseLoanInfoDataFn(errorModalState, param, loanDataState, queryClient, familyInfoDataState);
  }, [loanParam]);
  // 전세
  useEffect(() => {
    houseRentFInfoDataFn(errorModalState, param, rentFDataState, queryClient, familyInfoDataState);
  }, [rentFParam]);
  // 월세
  useEffect(() => {
    houseRentMInfoDataFn(errorModalState, param, rentMDataState, queryClient, familyInfoDataState);
  }, [rentMParam]);
  // 임대차
  useEffect(() => {
    houseRentPInfoDataFn(errorModalState, param, rentPDataState, queryClient, familyInfoDataState);
  }, [rentPParam]);

  const setContent = () => {
    const selectMenu = menuState.menu.find(item => item.active);
    const selectId = selectMenu?.id || 'saving';
    let grid = <HousingSaving type={type} />;
    if (selectId === 'loan') grid = <HousingLoan type={type} />;
    if (selectId === 'rentF') grid = <HousingRentF type={type} />;
    if (selectId === 'rentM') grid = <HousingRentM type={type} />;
    if (selectId === 'rentP') grid = <HousingRentP type={type} />;
    return grid;
  };

  const tabMenu = [
    { active: true, title: '주택자금저축', id: 'saving' },
    { active: false, title: '장기주택저당차입금', id: 'loan' },
    { active: false, title: '전세', id: 'rentF' },
    { active: false, title: '월세', id: 'rentM' },
    { active: false, title: '임대차', id: 'rentP' },
  ];
  const [menuState, setMenuState] = useState({ menu: tabMenu });

  const tabClickEvent = (selectItem: any) => {
    menuState.menu.forEach(item => {
      item.active = false;
      if (item.id === selectItem.id) item.active = true;
    });
    setMenuState({ menu: menuState.menu });
  };

  return (
    <div className="_creditcard_view_set_insert_div">
      <section className="_tab_button_div">
        <TabButton
          menu={menuState.menu}
          clickEvt={tabClickEvent}
          styleDef={{ height: '32px', fontSize: '13px' }}
        />
      </section>
      <section className="_content_div">
        <div className="_detail_info">{setContent()}</div>
      </section>
    </div>
  );
};

export default CreditCardSet;
